// 配送信息文案组件

import * as React from 'react';
import './index.css';
import { RichText } from '@wmfe/mach-pro-components-react';
import { USER_GET_MODES } from '@/src/pages/search/utils/constant';

interface Props {
  data: any;
  showRateInfo?: boolean; //是否展示店铺评分
  tabValue?: string; //是否自提
  setMarginTop?: number; //上边距
}

interface State {
}
const Intl = Mach.requireModule('Intl');
const SLABStrategy = Mach.requireModule('SLABStrategy');

export default class DeliveryInfo extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      imgTagWidth: 1
    };
  }

  render() {
    return (
      this.renderHalfRichText()
    );
  }

  /*
    ❗️❗️❗️❗️❗️
    由于首页配送这行完全使用富文本，会有以下问题 ：
    1.使用api下发图片：Android图片占位宽度不够，iOS行高和图片高度不一致，导致页面刷新的时候配送信息行会有很明显的闪动问题，影响交互效果；
    2.使用本地图片：Android富文本无法加载本地图片，即使加载成功也会有闪烁问题；
    为保证首页Feeds、金刚落地页、专区落地页、搜索结果页等页面不会被富文本的图片加载影响，
    采用配送icon前正常排列布局，配送icon后使用富文本展示配送费原价、现价的纯文案，待基建侧修复之后在换用上面renderRichText的富文本。
    特此说明。
  */
  renderHalfRichText = () => {
    const {
      data, showRateInfo = true, tabValue = '', setMarginTop = 0
    } = this.props;
    if (!data) return null;
    const isPickUp = tabValue === USER_GET_MODES.pickup;
    const {
      shopScoreInfo = {},
      deliveryTimeDesc = '',
      distance = {}, // 距离
      distanceIconUrl, // 距离图标
      deliveryFee = {},
      finalDeliveryFeeInfo = {},
      deliveryTimeIcon,
      deliveryTimeIconUrl,
      deliveryIconUrl,
      deliveryIconUrlV2,
      diningReadyTimeIconUrl = '', // 出餐时间图标, 自提特有
      diningReadyTimeDesc = '', // 出餐时长，自提特有
    } = data;

    const rateIcon = shopScoreInfo?.icon || 'assets://search/icon_shop_rate_star.png';
    const showTimeIcon = (isPickUp ? diningReadyTimeIconUrl : (deliveryTimeIconUrl || deliveryTimeIcon)) || 'assets://search/icon_time.png';
    const showTimeDesc = isPickUp ? diningReadyTimeDesc : deliveryTimeDesc;
    const showDeliveryIconUrl = deliveryIconUrlV2 || deliveryIconUrl || 'assets://search/rider-price.png';
    const showTime = showTimeIcon && showTimeDesc;
    const showDistanceIcon = isPickUp && distanceIconUrl;
    const distanceDesc = distance?.desc;
    const showDistance = showDeliveryIconUrl && distanceDesc;
    const disableShowDrawLineDeliveryFee = data?.deliveryFeeInfoStyle?.disableShowDrawLineDeliveryFee;
    const deliveryOriginPrice = deliveryFee?.displayText;
    const deliveryPrice = finalDeliveryFeeInfo?.price?.displayText;
    const isFinalDeliveryFree = deliveryPrice && (finalDeliveryFeeInfo?.price?.amount === 0);
    const priceCondition = finalDeliveryFeeInfo?.priceCondition;
    const showDeliveryPrice = deliveryPrice && deliveryOriginPrice && (deliveryFee.amount > finalDeliveryFeeInfo.price.amount);
    const showRate = shopScoreInfo?.score && showRateInfo;
    const hitGoldenStrategy = SLABStrategy?.hitGoldenStrategy?.() || false;

    const content: any[] = [];
    const fontSize = 12;
    const fontFamily = 'KeeTa-Regular';
    const boldFamily = 'KeeTa-Bold';
    const blackColor = '#222222';
    const grayColor = '#4D4D4D';
    const redColor = '#D90012';
    const greenColor = '#00B987';

    const origionDeliveryFeeTextColor = data?.deliveryFeeInfoStyle?.origionDeliveryFeeTextColor || blackColor;
    const drawLineDeliveryFeeTextColor = data?.deliveryFeeInfoStyle?.drawLineDeliveryFeeTextColor || grayColor;
    const finalDeliveryFeeTextColor = data?.deliveryFeeInfoStyle?.finalDeliveryFeeTextColor;

    // 分隔符样式
    // ❗️❗️❗️❗️❗️使用placeHolder会导致整个富文本向下偏移，先用空格顶上
    const placeholder = {
      type: 'text',
      text: ' ',
      fontSize,
      fontFamily,
    };

    // 配送费
    const deliverySubTags: any[] = [];

    // 配送费到手价
    if (showDeliveryPrice) {
      deliverySubTags.push({
        type: 'text',
        text: `${deliveryPrice}`,
        color: finalDeliveryFeeTextColor || (isFinalDeliveryFree ? (hitGoldenStrategy ? greenColor : redColor) : blackColor),
        fontWeight: hitGoldenStrategy ? 700 : 400,
        fontSize,
        fontFamily: hitGoldenStrategy ? boldFamily : fontFamily,
      });
    }

    // 配送费原价
    if (deliveryOriginPrice && (deliverySubTags.length === 0 || !disableShowDrawLineDeliveryFee)) {
      if (showDeliveryPrice) {
        deliverySubTags.push(placeholder);
      }
      deliverySubTags.push({
        type: 'text',
        text: deliveryOriginPrice,
        color: showDeliveryPrice ? drawLineDeliveryFeeTextColor : origionDeliveryFeeTextColor,
        fontSize,
        fontFamily,
        textDecoration: showDeliveryPrice ? 'line-through' : 'null'
      });
    }

    if (priceCondition) {
      if (showDeliveryPrice || deliveryOriginPrice) {
        deliverySubTags.push(placeholder);
      }
      deliverySubTags.push({
        type: 'text',
        text: `${priceCondition}`,
        color: grayColor,
        fontSize,
        fontFamily,
      });
    }
    content.push(...deliverySubTags);

    const pointBeforeTime = showRate && showTime;
    const pointBeforeDistance = ((showRate || showTime) && showDistance);
    const pointBeforeDelivery = (showRate || showTime || showDistance) && content.length > 0;
    const imgClassName = Mach.env.isAndroid ? 'img_icon_time_small shrink-zero' : 'img_icon_time shrink-zero';

    if (!showRate && !showTime && !showDistance && !deliveryOriginPrice && !deliveryFee && content.length === 0) {
      return null;
    }

    return (
      <view style={{ width: '100%', flexDirection: 'row', marginTop: setMarginTop }}>
        {/* 评分 */}
        {showRate && (
          <view className="rate-container">
            {rateIcon && <image className={imgClassName} style={{ marginBottom: Mach.env.isIOS ? 0 : 0.5 }} src={rateIcon} />}
            <text className="delivery-text shrink-zero" style={{ color: '#222222' }} content={shopScoreInfo?.score} />
          </view>
        )}

        {/* 配送时间 */}
        {pointBeforeTime && <view className="detailPoint" />}
        {showTime && (
          <view className="rate-container">
            <image className={imgClassName} src={showTimeIcon} style={{ marginBottom: Mach.env.isIOS ? 0.5 : 0, marginTop: Mach.env.isIOS ? 0 : 1 }} />
            <text className="delivery-text shrink-zero" content={showTimeDesc} />
          </view>
        )}

        {/* 配送距离 */}
        {pointBeforeDistance && <view className="detailPoint" />}
        {showDistance && (
          <view className="rate-container">
            {showDistanceIcon && <image className={imgClassName} src={showDistanceIcon} />}
            <text className="delivery-text shrink-zero" content={distanceDesc} />
          </view>
        )}

        {/* 配送icon */}
        {pointBeforeDelivery && <view className="detailPoint shrink-zero" />}
        {(deliveryOriginPrice || deliveryFee) && <image className={imgClassName} style={{ marginTop: Mach.env.isIOS ? 0.5 : 1.5 }} src={showDeliveryIconUrl} />}

        {/* 配送原价和现价的富文本 */}
        {content.length > 0 && <RichText className="shop-info-rich-text-half" content={content} />}
      </view>
    );
  }

  /**
   * 暂时不用
   * @returns
   */
  renderRichText = () => {
    const { data, showRateInfo = true, tabValue = '' } = this.props;
    if (!data) return null;
    const isPickUp = tabValue === USER_GET_MODES.pickup;
    const {
      shopScoreInfo = {},
      deliveryTimeDesc = '',
      // shopCategoryName = '',
      distance = {}, // 距离
      distanceIconUrl, // 距离图标
      deliveryFee = {},
      finalDeliveryFeeInfo = {},
      deliveryTimeIcon,
      deliveryTimeIconUrl,
      deliveryIconUrl,
      diningReadyTimeIconUrl = '', // 出餐时间图标, 自提特有
      diningReadyTimeDesc = '', // 出餐时长，自提特有
    } = data;

    const showTimeIcon = (isPickUp ? diningReadyTimeIconUrl : (deliveryTimeIconUrl || deliveryTimeIcon)) || 'assets://search/icon_time.png';
    const showTimeDesc = isPickUp ? diningReadyTimeDesc : deliveryTimeDesc;
    const showDeliveryIconUrl = deliveryIconUrl || 'assets://search/rider-price.png';
    const showTime = showTimeIcon && showTimeDesc;
    const showDistanceIcon = isPickUp && distanceIconUrl;
    const showDistance = showDeliveryIconUrl && distance?.desc;
    const deliveryOriginPrice = deliveryFee?.displayText;
    const deliveryPrice = finalDeliveryFeeInfo?.price?.displayText;
    const isFinalDeliveryFree = deliveryPrice && (finalDeliveryFeeInfo?.price?.amount === 0);
    const priceCondition = finalDeliveryFeeInfo?.priceCondition;
    const showDeliveryPrice = deliveryPrice && deliveryOriginPrice && (deliveryFee.amount > finalDeliveryFeeInfo.price.amount);
    const showRate = shopScoreInfo?.score && showRateInfo;
    const isIOS = Mach.env.isIOS;

    const content: any[] = [];
    const fontSize = 12;
    const iconSize = isIOS ? 14 : fontSize; // 安卓端需要跟字号保持一致，否则无法居中对齐
    const lineHeight = 19;
    const verticalOffset = 0; // Math.floor(iconSize-lineHeight) * 0.5; // 图片使用,仅 iOS 支持
    const verticalAlignment = undefined; // 图片使用, 仅 Android 支持： native未解析，暂时无用
    const fontFamily = 'KeeTa-Regular';
    const blackColor = '#222222';
    const grayColor = '#4D4D4D';
    const redColor = '#D90012';
    // KeeTa字体偏下，需要手动对齐: 仅iOS生效
    const baselineOffset = isIOS ? Math.floor(lineHeight - fontSize) * 0.5 : undefined; // 文字使用
    // 分隔符样式
    const placeholder = {
      type: 'placeholder',
      width: 4
    };
    const seperatorTags = [placeholder,
      {
        type: 'text',
        fontSize: isIOS ? 20 : fontSize, // ios端小圆点偏小，手动设大一点
        fontFamily,
        text: '·',
        color: '#C2C2C2'
      },
      placeholder
    ];
    // 图标与文字间距
    const textPlaceholder = {
      type: 'placeholder',
      width: 2
    };

    // 评分
    if (showRate) {
      content.push(
        {
          type: 'image',
          src: shopScoreInfo?.icon || 'assets://search/icon_shop_rate_star.png',
          width: iconSize,
          height: iconSize,
          baselineOffset,
          verticalOffset,
          verticalAlignment
        },
        textPlaceholder,
        {
          type: 'text',
          fontFamily,
          fontSize,
          baselineOffset,
          color: blackColor,
          text: shopScoreInfo?.score
        }
      );
    }

    // 配送时长和距离
    if (showTime) {
      if (content.length > 0) {
        content.push(...seperatorTags);
      }
      content.push(
        {
          type: 'image',
          src: showTimeIcon,
          width: iconSize,
          height: iconSize,
          baselineOffset,
          verticalOffset,
          verticalAlignment
        },
        textPlaceholder,
        {
          type: 'text',
          fontFamily,
          fontSize,
          baselineOffset,
          color: grayColor,
          text: showTimeDesc,
        }
      );
    }

    if (showDistance) {
      if (content.length > 0) {
        content.push(...seperatorTags);
      }
      // 自提才展示距离图标
      if (showDistanceIcon) {
        content.push(
          {
            type: 'image',
            src: distanceIconUrl,
            width: iconSize,
            height: iconSize,
            verticalOffset,
            verticalAlignment
          },
          textPlaceholder
        );
      }
      content.push({
        type: 'text',
        fontFamily,
        fontSize,
        baselineOffset,
        color: grayColor,
        text: distance?.desc,
      });
    }

    // 配送费
    const deliverySubTags: any[] = [];
    if (deliveryOriginPrice || deliveryPrice) {
      deliverySubTags.push(
        {
          type: 'image',
          src: showDeliveryIconUrl,
          width: iconSize,
          height: iconSize,
          verticalOffset,
          verticalAlignment
        },
        textPlaceholder
      );
    }

    // 配送费到手价
    if (showDeliveryPrice) {
      deliverySubTags.push({
        type: 'text',
        text: `${deliveryPrice}`,
        color: isFinalDeliveryFree ? redColor : blackColor,
        baselineOffset,
        fontSize,
        fontFamily,
      });
    }

    // 配送费原价
    if (deliveryOriginPrice) {
      if (showDeliveryPrice) {
        deliverySubTags.push(placeholder);
      }
      deliverySubTags.push({
        type: 'text',
        text: deliveryOriginPrice,
        color: grayColor,
        fontSize,
        fontFamily,
        baselineOffset,
        textDecoration: showDeliveryPrice ? 'line-through' : 'null'
      });
    }

    if (priceCondition) {
      if (showDeliveryPrice || deliveryOriginPrice) {
        deliverySubTags.push(placeholder);
      }
      deliverySubTags.push({
        type: 'text',
        text: `${priceCondition}`,
        color: grayColor,
        fontSize,
        baselineOffset,
        fontFamily,
      });
    }

    if (deliverySubTags.length > 1) {
      if (content.length > 0) {
        content.push(...seperatorTags);
      }
      content.push(...deliverySubTags);
    }
    if (content.length > 0) {
      return (<RichText className="shop-info-rich-text" style={{ lineHeight }} content={content} />);
    }
    return null;
  }
}
